import React from 'react';

import styled from 'styled-components';
import {CardContainer} from '../card/Card';
import {RouterLink} from '../btn/RouterLink';
import IconContainer, {Icon} from '../icon/Icon';
import {Btn} from '../btn/Btn';

const CollapseBtn = styled(Btn)`
    width: 100%;
    display: flex;
    justify-content: space-between;
    font-weight: 400;
    line-spacing: 0.6;
    padding: 12px;
    margin: 0;
    &:hover {
        color: var(--primary-dark);
    }
`;

const Wrapper = styled.div`
    margin-bottom: 8px;
    position: relative;
`;

const Accordion = ({children, onDelete, showErrors, isDisabled, accordionHeader, ...props}) => (
    <Wrapper>
        <AccordionHeader showErrors={showErrors}>
            {onDelete && (
                <AccordionDeleteBtn color="danger" disabled={isDisabled} onClick={() => onDelete()}>
                    <Icon icon="Clear" />
                </AccordionDeleteBtn>
            )}
            <CollapseBtn {...props}>{accordionHeader}</CollapseBtn>
        </AccordionHeader>
        {children}
    </Wrapper>
);

const AccordionHeader = styled(CardContainer)`
    margin-bottom: 2px;
    align-items: center;
    background: #f7fbff;
    border-color: #c2cfdc;
    padding: 0;

    &:hover {
        background: var(--primary-light);
        border-color: var(--primary);
    }

    ${({showErrors}) => {
        if (showErrors)
            return `
        background: var(--danger-light);
        border-color: var(--danger);
        a {
            color: var(--danger);
        }
        ${RouterLink}:hover{
            color: var(--danger-dark) !important;
        }
    `;
    }}
`;

const AccordionBody = styled(CardContainer)`
    background: #f7f7fa5c;
    margin-bottom: 40px;
    padding: 12px;
`;

const AccordionDeleteBtn = styled(Btn)`
        position: absolute;
        top: 0;
        right: 0;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        transform: translate(-4px, -8px);
        padding: 0;
        display: inline-block;

        ${IconContainer} svg {
            width: 12px;
            height: 12px;
            margin: auto;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: white !important;
        }
    }
`;

Accordion.Header = AccordionHeader;
Accordion.Body = AccordionBody;
export {Accordion, AccordionHeader, AccordionBody};
